import { useRef, useState } from 'react'

export default function MandatorySkillCheckbox (props) {
  const { readOnly, mandatory, skill_id: skillId } = props
  const [mandatorySkillState, setMandatorySkillState] = useState(!!mandatory)
  const containerRef = useRef(null)

  const _checkMandatory = () => {
    const form = $(containerRef.current).parents('form')
    setMandatorySkillState(!mandatorySkillState)
    $('button[type="submit"]', form).prop('disabled', false)
  }

  return (
    <div ref={containerRef}>
      {readOnly
        ? (
          <div className={mandatory ? 'must-have active' : 'must-have'} />
          )
        : (
          <div className='mandatory-skill'>
            <input
              type='hidden'
              name={`mandatory[${skillId}]`}
              value={mandatorySkillState ? 1 : 0}
            />
            <label className='checkbox'>
              <input
                type='checkbox'
                onChange={_checkMandatory}
                checked={mandatorySkillState}
              />
              <span className='box'> </span>
            </label>
          </div>
          )}
    </div>
  )
}
